import { createClient } from "contentful";

export const useContentfulNews = () => {
  const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_DELIVERY_API_KEY,
    host: process.env.REACT_APP_CONTENTFUL_PUBLISHED_HOST,
  });

  const getNews = async () => {
    try {
      const entries = await client.getEntries({
        content_type: "news",
        select: "fields",
      });

      const sanitizedEntries = entries.items.map((item) => ({
        ...item.fields,
      }));

      sanitizedEntries.sort((a, b) => {
        const ta = a.date ? new Date(a.date).getTime() : NaN;
        const tb = b.date ? new Date(b.date).getTime() : NaN;
        const na = Number.isFinite(ta) ? ta : Number.NEGATIVE_INFINITY;
        const nb = Number.isFinite(tb) ? tb : Number.NEGATIVE_INFINITY;
        return nb - na;
      });

      return sanitizedEntries;
    } catch (error) {
      console.log(`Error fetching news: ${error.message}`);
    }
  };

  return { getNews };
};
